import type { AuthMatch } from '@kernel';

export function matchAuth<T>(
  values: readonly T[],
  match: AuthMatch,
  predicate: (value: T) => boolean,
): boolean {
  if (match === 'ALL') return values.every(predicate);
  if (match === 'NONE') return values.every((v: T) => !predicate(v));

  return values.some(predicate);
}
